module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAABIklEQVQ4jdXUsSuFURjH8Q/dpJRsNilMBkahKAuDUixmBotNGQz4H5RVmUyy3IWBkhWzJH+BKAwKHfcd7vXcl3vlKt86w/t7zvnWOec9T9P51pwq7GIYPbH0QQHXOMRitWILRtFelqfvbswEXYk2dGHo05x7nCZpERNhWYn9kFTSX2VOsZAJb7FTVlhCJzaDpkQrVnPWTaYzfcMJxsuKFxhAU9CV6MBd3rrmMP0XKOQojrJDz+MBZ9kI5ElXQlLJK0ZCmtGQ7f/pmS5jNqSRPWzXKk1PdCykkZt6pPPZ+BH//6LSJU2HNJKayUGt0gVMhTTSUY80de6+LxpKIjWiq5B+IX3CZUhr5P/cfsN+qRcM4vgXfL14TtINrNX41r/jEevvvp8we8gakIMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/m_icon3.png
// module id = nyud
// module chunks = 2